// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.wlf-controls[data-v-5cbb5fc0] {
  margin-bottom: 2rem;
  display: none;
@media (min-width: 768px) {
    display: block;
}
}
.wlf-controls__container[data-v-5cbb5fc0],
.wlf-nav[data-v-5cbb5fc0] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.wlf-nav[data-v-5cbb5fc0] {
  flex: 1 1 0;
  margin: 25px clamp(15px, 2.5vw, 40px);
}
.wlf-nav__bar[data-v-5cbb5fc0] {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  background: #aec7ce;
}
.wlf-nav__bar__inner[data-v-5cbb5fc0] {
  transition: all 0.5s ease;
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0px;
  background: var(--green);
}
.wlf-nav__level[data-v-5cbb5fc0] {
  position: relative;
  border: none;
  background: none;
  padding: 0;
}
.wlf-nav__text[data-v-5cbb5fc0] {
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  line-height: 150%;
  white-space: nowrap;
}
.wlf-nav__dot--large[data-v-5cbb5fc0] {
  width: 40px;
  height: 40px;
  position: relative;
  border-radius: 50%;
  background: var(--green);
  color: white;
  background: var(--white);
  color: var(--charcoal);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
}
.wlf-nav__dot__inner[data-v-5cbb5fc0] {
  color: inherit;
}
.wlf-nav__dot__inner svg[data-v-5cbb5fc0] {
  display: block;
}
.wlf-nav__dot--small[data-v-5cbb5fc0] {
  width: 14px;
  height: 14px;
  display: block;
  background: var(--green);
  background: #aec7ce;
  border-radius: 50%;
  border: none;
  appearance: none;
  transition: all 0.4s ease;
  transform: scale(1);
}
.wlf-nav__dot.is_past[data-v-5cbb5fc0],
.wlf-nav__dot.is_current[data-v-5cbb5fc0] {
  background: var(--green);
  color: white;
}
.wlf-nav__dot.is_current[data-v-5cbb5fc0] {
}
.wlf-nav__dot[data-v-5cbb5fc0] {
  cursor: pointer;
}
.wlf-nav__dot--small.is_past[data-v-5cbb5fc0]:focus,
.wlf-nav__dot--small.is_past[data-v-5cbb5fc0]:hover {
  transform: scale(1.71);
}
.wlf-controls__direction[data-v-5cbb5fc0] {
  /* min-width: 150px; */
}
@media screen and (max-width: 900px) {
.wlf-nav__dot--large[data-v-5cbb5fc0] {
    width: 38px;
    height: 38px;
}
.wlf-nav__dot--small[data-v-5cbb5fc0] {
    width: 12px;
    height: 12px;
}
}
@media screen and (max-width: 800px) {
.wlf-controls__container[data-v-5cbb5fc0] {
    flex-wrap: wrap;
}
.wlf-nav[data-v-5cbb5fc0] {
    width: 100%;
    order: 1;
    flex: auto;
    margin: 25px 0px 65px;
}
.wlf-controls__direction[data-v-5cbb5fc0] {
    order: 2;
    width: 50%;
}
.wlf-nav__dot--small[data-v-5cbb5fc0] {
    display: none;
}
.wlf-nav__dot--small.is_current_level[data-v-5cbb5fc0] {
    display: block;
}
}
@media screen and (max-width: 768px) {
.wlf-nav__dot--small[data-v-5cbb5fc0] {
    width: 10px;
    height: 10px;
}
.wlf-nav__dot--large[data-v-5cbb5fc0] {
    width: 34px;
    height: 34px;
}
.wlf-nav__text[data-v-5cbb5fc0] {
    display: none;
}
.is_current + .wlf-nav__text[data-v-5cbb5fc0] {
    display: block;
}
.wlf-nav__text[data-v-5cbb5fc0] {
    font-size: 12px;
}
}
.wlf-nav__dot.is_current_level[data-v-5cbb5fc0] {
  animation: bubble-5cbb5fc0 0.3s linear forward 0.3s;
}
@keyframes bubble-5cbb5fc0 {
0% {
    transform: scale(1);
}
50% {
    transform: scale(1.1);
}
100% {
    transform: scale(1);
}
}
`, "",{"version":3,"sources":["webpack://./../assets/vue/ToolNavigation.vue"],"names":[],"mappings":";AA2DA;EACE,mBAAmB;EACnB,aAAa;AAEb;IACE,cAAc;AAChB;AACF;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;AACrB;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,UAAU;EACV,wBAAwB;AAC1B;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;AAEA;EACE,cAAc;AAChB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AAEA;;EAEE,wBAAwB;EACxB,YAAY;AACd;AAEA;AACA;AAEA;EACE,eAAe;AACjB;AAEA;;EAEE,sBAAsB;AACxB;AAEA;EACE,sBAAsB;AACxB;AAEA;AACE;IACE,WAAW;IACX,YAAY;AACd;AAEA;IACE,WAAW;IACX,YAAY;AACd;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,WAAW;IACX,QAAQ;IACR,UAAU;IACV,qBAAqB;AACvB;AAEA;IACE,QAAQ;IACR,UAAU;AACZ;AAEA;IACE,aAAa;AACf;AAEA;IACE,cAAc;AAChB;AACF;AAEA;AACE;IACE,WAAW;IACX,YAAY;AACd;AAEA;IACE,WAAW;IACX,YAAY;AACd;AAEA;IACE,aAAa;AACf;AAEA;IACE,cAAc;AAChB;AAEA;IACE,eAAe;AACjB;AACF;AAEA;EACE,mDAA0C;AAC5C;AAEA;AACE;IACE,mBAAmB;AACrB;AACA;IACE,qBAAqB;AACvB;AACA;IACE,mBAAmB;AACrB;AACF","sourcesContent":["<script setup>\nimport {computed, inject} from 'vue'\nimport {useStepStore} from \"./stores/steps\";\n\nconst stepStore = useStepStore()\nconst goToStep = inject('goToStep')\n\nconst props = defineProps({\n  steps: Array,\n  count: Number\n})\n\nconst currentIndex = computed(() => {\n  return props.steps.findIndex(step => step.key === stepStore.currentStepKey)\n})\n</script>\n\n<template>\n  <div class=\"wlf-controls\">\n    <div class=\"g-container wlf-controls__container\">\n      <div class=\"wlf-nav\" role=\"navigation\" aria-labelledby=\"steps-nav\">\n        <h2 :id=\"`${count}-steps-nav`\" class=\"sr-only\">Step Navigation</h2>\n        <div\n            class=\"wlf-nav__bar\"\n            role=\"progressbar\"\n            :aria-valuenow=\"currentIndex\"\n            :aria-valuemin=\"0\"\n            :aria-valuemax=\"steps.length - 1\"\n            :aria-labelledby=\"`${count}-steps-nav`\"\n        >\n          <div class=\"wlf-nav__bar__inner\"></div>\n        </div>\n        <template v-for=\"(step, index) in steps\" :key=\"index\">\n          <button\n              class=\"wlf-nav__level\"\n              @click=\"goToStep(step.key)\"\n              :aria-label=\"index < currentIndex ? `Go to ${step.name}` : `Step ${index + 1}: ${step.name}`\"\n              :aria-current=\"step.key === stepStore.currentStepKey ? 'step' : null\"\n          >\n            <span\n                class=\"wlf-nav__dot wlf-nav__dot--large\"\n                :class=\"{\n                is_current: step.key === stepStore.currentStepKey,\n                is_past: index < currentIndex\n              }\"\n            >\n              <span class=\"wlf-nav__dot__inner\">\n                <component :is=\"step.icon\" class=\"h-icon\"></component>\n              </span>\n            </span>\n            <span class=\"wlf-nav__text\" v-text=\"step.name\"></span>\n          </button>\n        </template>\n      </div>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n.wlf-controls {\n  margin-bottom: 2rem;\n  display: none;\n\n  @media (min-width: 768px) {\n    display: block;\n  }\n}\n.wlf-controls__container,\n.wlf-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n\n.wlf-nav {\n  flex: 1 1 0;\n  margin: 25px clamp(15px, 2.5vw, 40px);\n}\n\n.wlf-nav__bar {\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 2px;\n  background: #aec7ce;\n}\n\n.wlf-nav__bar__inner {\n  transition: all 0.5s ease;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 0px;\n  background: var(--green);\n}\n\n.wlf-nav__level {\n  position: relative;\n  border: none;\n  background: none;\n  padding: 0;\n}\n\n.wlf-nav__text {\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 14px;\n  line-height: 150%;\n  white-space: nowrap;\n}\n\n.wlf-nav__dot--large {\n  width: 40px;\n  height: 40px;\n  position: relative;\n  border-radius: 50%;\n  background: var(--green);\n  color: white;\n  background: var(--white);\n  color: var(--charcoal);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.4s ease;\n}\n\n.wlf-nav__dot__inner {\n  color: inherit;\n}\n\n.wlf-nav__dot__inner svg {\n  display: block;\n}\n\n.wlf-nav__dot--small {\n  width: 14px;\n  height: 14px;\n  display: block;\n  background: var(--green);\n  background: #aec7ce;\n  border-radius: 50%;\n  border: none;\n  appearance: none;\n  transition: all 0.4s ease;\n  transform: scale(1);\n}\n\n.wlf-nav__dot.is_past,\n.wlf-nav__dot.is_current {\n  background: var(--green);\n  color: white;\n}\n\n.wlf-nav__dot.is_current {\n}\n\n.wlf-nav__dot {\n  cursor: pointer;\n}\n\n.wlf-nav__dot--small.is_past:focus,\n.wlf-nav__dot--small.is_past:hover {\n  transform: scale(1.71);\n}\n\n.wlf-controls__direction {\n  /* min-width: 150px; */\n}\n\n@media screen and (max-width: 900px) {\n  .wlf-nav__dot--large {\n    width: 38px;\n    height: 38px;\n  }\n\n  .wlf-nav__dot--small {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .wlf-controls__container {\n    flex-wrap: wrap;\n  }\n\n  .wlf-nav {\n    width: 100%;\n    order: 1;\n    flex: auto;\n    margin: 25px 0px 65px;\n  }\n\n  .wlf-controls__direction {\n    order: 2;\n    width: 50%;\n  }\n\n  .wlf-nav__dot--small {\n    display: none;\n  }\n\n  .wlf-nav__dot--small.is_current_level {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .wlf-nav__dot--small {\n    width: 10px;\n    height: 10px;\n  }\n\n  .wlf-nav__dot--large {\n    width: 34px;\n    height: 34px;\n  }\n\n  .wlf-nav__text {\n    display: none;\n  }\n\n  .is_current + .wlf-nav__text {\n    display: block;\n  }\n\n  .wlf-nav__text {\n    font-size: 12px;\n  }\n}\n\n.wlf-nav__dot.is_current_level {\n  animation: bubble 0.3s linear forward 0.3s;\n}\n\n@keyframes bubble {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
